import users from 'api/users'
import auth from 'api/auth'
import manipulators from 'api/manipulators'
import cookies from 'utilities/cookies'
import * as types from '../mutation-types'
import * as namedTypes from '../namespaced-mutation-types'

const Promise = window.Promise || require('promise')

export const updateRecruitedResume = ({ commit }, data) => {
  commit(types.COMPANY_RECRUITED_RESUME, data)
}

export const fetchRecruitedResumeById = ({ commit, rootState }, id) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.getRecruitedResumeById(
      rootState.manipulators.token,
      id
    ).then((data) => {
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.COMPANY_RECRUITED_RESUME, {})
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const starOrArchiveRecruitedResume = ({ commit, rootState }, payload) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.starOrArchiveRecruitedResumes(
      rootState.manipulators.token,
      payload.id,
      payload.type,
      payload.status
    ).then(() => {
      return Promise.resolve()
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateRecruitedResumes = ({ commit, rootState }, data) => {
  commit(types.COMPANY_RECRUITED_RESUMES, data)
}

export const fetchRecruitedResumes = ({ commit, rootState }, params = { page: 1 }) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.getRecruitedResumes(
      rootState.manipulators.token,
      params
    ).then((data) => {
      data.results.items = data.results.items.map(item => {
        item.checked = false
        return item
      })
      commit(types.COMPANY_RECRUITED_RESUMES, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.COMPANY_RECRUITED_RESUMES, {})
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const switchManipulatorCompanyVacancyStatus = ({ commit, dispatch, rootState }, payload) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.switchCompanyVacancyStatus(
      rootState.manipulators.token,
      {
        vacancies: payload.vacancies
      },
      payload.status
    ).then((data) => {
      if (payload.status === 'deleted') {
        if (typeof payload.params === 'undefined') {
          payload.params = { page: 1 }
        }
        dispatch('fetchManipulatorCompanyVacancies', payload.params)
      } else {
        let list = JSON.parse(JSON.stringify(rootState.manipulators.companyVacancies))
        list.items = list.items.map(item => {
          if (payload.vacancies.indexOf(item.id) >= 0) {
            item.opening = payload.status
          }
          return item
        })
        commit(types.MANIPULATOR_COMPANY_VACANCIES, list)
      }
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateManipulatorCompanyVacancies = ({ commit }, data) => {
  commit(types.MANIPULATOR_COMPANY_VACANCIES, data)
}

export const fetchManipulatorCompanyVacancies = ({ commit, rootState }, params = { page: 1 }) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.getCompanyVacancies(
      rootState.manipulators.token,
      params
    ).then((data) => {
      commit(types.MANIPULATOR_COMPANY_VACANCIES, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.MANIPULATOR_COMPANY_VACANCIES, {})
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchManipulatorCompanyByAlias = ({ commit, rootState }, alias) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.getCompanyByAlias(
      rootState.manipulators.token,
      alias
    ).then((data) => {
      commit(types.MANIPULATOR_COMPANY, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.MANIPULATOR_COMPANY, {})
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchManipulatorFirstCompany = ({ commit, rootState }) => {
  if (rootState.manipulators.token !== '') {
    return manipulators.getFirstCompany(
      rootState.manipulators.token
    ).then((data) => {
      commit(types.MANIPULATOR_COMPANY, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.MANIPULATOR_COMPANY, {})
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const reSentActiveAccountEmail = ({ commit, rootState }) => {
  return manipulators.reSentActiveAccountEmail(rootState.manipulators.token).then((data) => {
    return Promise.resolve()
  }, () => {
    return Promise.reject()
  })
}

export const forgotPassword = ({ commit }, loginData) => {
  return auth.manipulatorForgotPassword(loginData).then((data) => {
    return Promise.resolve(data)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const updateManipulatorData = ({ commit, rootState }, payload) => {
  return manipulators.updateById(
    rootState.manipulators.token,
    rootState.manipulators.userData.id,
    payload
  ).then((data) => {
    commit(namedTypes.MANIPULATOR_DATA, data.user, { root: true })
    commit(namedTypes.MANIPULATOR_TOKEN, data.token, { root: true })
    try {
      window.sessionStorage.setItem('debutToken', data.token)
      window.sessionStorage.setItem('debutUserData', JSON.stringify(data.user))
    } catch (e) {}
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const fetchUserData = ({ commit, rootState }) => {
  if (rootState.manipulators.token !== '') {
    return users.get(rootState.manipulators.token).then((data) => {
      commit(types.MANIPULATOR_DATA, data.user)
      commit(types.MANIPULATOR_TOKEN, data.token)
      try {
        window.sessionStorage.setItem('debutManipulatorToken', data.token)
        window.sessionStorage.setItem('debutManipulatorData', JSON.stringify(data.user))
      } catch (e) {}
      return Promise.resolve(data)
    }, (err) => {
      commit(types.MANIPULATOR_DATA, {})
      commit(types.MANIPULATOR_TOKEN, '')
      cookies.remove('debutManipulatorToken')
      try {
        window.sessionStorage.removeItem('debutManipulatorToken')
        window.sessionStorage.removeItem('debutManipulatorData')
      } catch (e) {}
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const logout = ({ commit }) => {
  commit(types.MANIPULATOR_DATA, {})
  commit(types.MANIPULATOR_TOKEN, '')
  cookies.remove('debutManipulatorToken')
  try {
    window.sessionStorage.removeItem('debutManipulatorToken')
    window.sessionStorage.removeItem('debutManipulatorData')
  } catch (e) {}
  return Promise.resolve()
}

export const setToken = ({ commit }, token) => {
  commit(types.MANIPULATOR_TOKEN, token)
}

export const setUserData = ({ commit }, data) => {
  commit(types.MANIPULATOR_DATA, data)
}



// WEBPACK FOOTER //
// ./src/vuex/manipulators/actions.js